
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artists",
      function () {
        return require("private-next-pages/artists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artists"])
      });
    }
  